import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {SingleAccountOrderDialogComponent} from "./single-account-order-dialog/SingleAccountOrderDialogComponent";
import {
    EquityOrderType,
    MultiAccountEquityWizardData
} from "../place-multi-equity-order-wizard/models/MultiAccountEquityWizardData";
import {MultiAccountEquityOrderWizard} from "../place-multi-equity-order-wizard/MultiAccountEquityOrderWizard";
import {PricingInstruction} from "../../../../orders/models/PricingInstruction";
import {OrderLifetime, OrderSide} from "../../../../orders/models/OrderRecord";
import {MultiOrderStore} from "../place-multi-equity-order-wizard/store/MultiOrderStore";
import {EquityWizardData} from "../place-equity-order-wizard/models/EquityWizardData";
import {AsxInstrumentUtil} from "../../../../js/util/asx/AsxInstrumentUtil";
import {PriceStrategy} from "../../../../components/inputs/price/input/PriceStrategy";
import {Exchange} from "../../../../instruments/exchange/Exchange";
import {PriceStrategyService} from "../../../../components/inputs/price/service/PriceStrategyService";

export class MultiAccountOrdersDialogService {

    public static readonly id = "multiAccountOrderDialogService";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService,
                       private readonly priceStrategyService: PriceStrategyService) {
    }

    public openSingleAccountDialog(orderStore: MultiOrderStore, singleOrder: Partial<EquityWizardData> | null = {}, index: number | null) {
        const order = this.initOrder(singleOrder);
        const options: IModalSettings = {
            size: "lg",
            component: SingleAccountOrderDialogComponent,
            resolve: {
                orderStore: () => orderStore,
                singleOrder: () => order,
                index: () => index
            }
        };
        this.$uibModal.open(options);
    }

    private initOrder(orderPrototype: Partial<EquityWizardData> | null): EquityWizardData {
        const code = orderPrototype?.code;
        let exchange = orderPrototype?.exchange;
        if ((exchange == null) && (code != null)) {
            exchange = AsxInstrumentUtil.guessExchange(code);
        }

        let strategy: PriceStrategy | undefined;
        if (code != null) {
            strategy = this.priceStrategyService.forCode(code);
        }

        let lifetime: OrderLifetime | undefined = orderPrototype?.lifetime ?? OrderLifetime.GOOD_TILL_CANCEL;
        if (exchange === Exchange.AXW) {
            lifetime = OrderLifetime.END_OF_DAY;
        }
        const name = orderPrototype?.name;
        const orderNumber = orderPrototype?.orderNumber;
        const quantity = orderPrototype?.quantity ?? 0;
        const side = orderPrototype?.side ?? OrderSide.BUY;
        const type = EquityOrderType.QUANTITY;
        const limit = orderPrototype?.limit;
        const portfolio = orderPrototype?.portfolio;
        const quote = orderPrototype?.quote;
        const pricingInstruction = orderPrototype?.pricingInstruction ?? PricingInstruction.LIMIT;
        const totalValue = orderPrototype?.totalValue ?? 0;
        const isStopLoss = orderPrototype?.isStopLoss ?? false;
        const isParentOrder = orderPrototype?.isParentOrder ?? false;
        const childOrders = orderPrototype?.childOrders ?? [];

        return {
            orderNumber,
            code,
            name,
            exchange,
            side,
            quantity: Math.abs(quantity),
            limit,
            lifetime,
            pricingInstruction,
            type,
            totalValue,
            portfolio,
            quote,
            strategy,
            isStopLoss,
            isParentOrder,
            childOrders
        };
    }

    public openMultiAccountDialog(wizardData?: MultiAccountEquityWizardData) {
        let order: MultiAccountEquityWizardData = {
            advice: undefined,
            current: {
                code: undefined,
                exchange: undefined,
                expiry: undefined,
                limit: 0,
                name: undefined,
                portfolio: undefined,
                pricingInstruction: PricingInstruction.LIMIT,
                quote: undefined,
                strategy: undefined,
                side: OrderSide.BUY,
                lifetime: OrderLifetime.GOOD_TILL_CANCEL,
                quantity: 0,
                totalValue: 0,
                type: EquityOrderType.QUANTITY,
                isStopLoss: false,
                stopLossLimit: null
            },
            orders: []
        };

        if (wizardData) {
            order = wizardData;
        }

        const options: IModalSettings = {
            size: "lg",
            component: MultiAccountEquityOrderWizard,
            resolve: {
                order: () => order,
            }
        };
        const instance = this.$uibModal.open(options);
        return instance.result;
    }
}
